import { Box, Typography, styled } from "@mui/material";

export const DropzoneContainer = styled(Box)({
  border: "2px dashed #E5E7EB",
  borderRadius: "12px",
  padding: "32px",
  textAlign: "center",
  cursor: "pointer",
  transition: "all 0.2s ease",
  backgroundColor: "#FAFAFA",
  "&:hover": {
    borderColor: "#0B494B",
    backgroundColor: "#F0FDFA",
  },
  "&.active": {
    borderColor: "#0B494B",
    backgroundColor: "#F0FDFA",
  },
});

export const IconContainer = styled(Box)({
  marginBottom: "12px",
  display: "flex",
  justifyContent: "center",
});

export const DropzoneSmallText = styled(Typography)({
  color: "#9CA3AF",
  fontSize: "12px",
});
